import styled from "styled-components";

export const ButtonStyled = styled.button`
  /* display: flex; */
  /* align-items: center;
  justify-content: center; */
  border: none;
  padding: 20px 30px;
  font-weight: bold;
  background-color: #126bdc;
  color: #fff;

  font-size: 16px;
  cursor: pointer;

  border: 1px solid #126bdc;
  border-radius: 13px;
  font-family: "Red Hat Display", Sans-serif !important;

  box-shadow: 0 8px 10px rgb(10 107 220 / 28%);
  transition: all 0.25s ease;
   &:disabled {
   background-color:rgb(164, 205, 248); 
      color: #356599;
      cursor: not-allowed;
      opacity: 0.7;
      transform: scale(1)
   }
`;
